"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNamedReport = exports.generateNamedReportId = exports.generateUnnamedMultiReportId = exports.generateUnnamedReportId = exports.NAMED_REPORT_PREFIX = exports.UNNAMED_REPORT_PREFIX = exports.UNNAMED_MULTI_CAMPAIGN_REPORT_PREFIX = void 0;
exports.normalizeReportContextToStoredReport = normalizeReportContextToStoredReport;
exports.normalizeStoredReportToReportContext = normalizeStoredReportToReportContext;
exports.getStartFinishOfStoredReport = getStartFinishOfStoredReport;
const lodash_set_1 = __importDefault(require("lodash.set"));
const granularity_1 = require("../reporterDb/granularity.js");
const uuid_1 = require("uuid");
const arrays_1 = require("../../helpers/arrays");
const dateISO_1 = require("../../helpers/dateISO");
const dateRange_1 = require("../genericReport/dateRange");
const dbTableCampaign_1 = require("../reporterDb/dbTableCampaign");
const dateRange_2 = require("./dateRange");
const granularity_2 = require("./granularity");
function normalizeReportContextToStoredReport({ id, name, campaignId, filters = {}, splits = [], defaultFilters, schedule, orderedColumns, hiddenColumns, email, }) {
    var _a, _b, _c, _d, _e;
    const dateRange = (_a = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.range) === null || _a === void 0 ? void 0 : _a.value;
    const dateRangeConfig = dateRange_2.PERIOD_CONFIGS[dateRange];
    let defaultFiltersRange;
    if (dateRangeConfig) {
        defaultFiltersRange = {
            range: {
                unit: dateRangeConfig.period,
                startUnitsAgo: dateRangeConfig.startUnitsAgo,
                endUnitsAgo: dateRangeConfig.endUnitsAgo,
            },
        };
    }
    else {
        defaultFiltersRange = {
            start: {
                value: (_b = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.start) === null || _b === void 0 ? void 0 : _b.value,
            },
            finish: {
                value: (_c = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.finish) === null || _c === void 0 ? void 0 : _c.value,
            },
        };
    }
    //DPLAT-808 TODO Until next prod deploy, we need to support both defaultFilters.granularity and splits for backward compatibility in scheduled reports. Plan:
    //1. Support set/get granularity in Time split (in this PR) + keep defaultFilters.granularity in stored repotrs
    //2. Deploy to prod, so scheduled reports will accept value in Time split
    //3. Remove defaultFilters.granularity from code. Then only granularity in Time split will be supported
    let granularity = granularity_1.GRANULARITY_TYPES.ALL;
    if (splits
        .map((s) => s.id)
        .includes(dbTableCampaign_1.DimensionIds.GRANULARITY_COLUMN_ID)) {
        granularity = (_e = (_d = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.granularity) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : (0, granularity_2.getGranularityFromSplits)(splits);
    }
    return {
        id,
        name: name ||
            `Report for ${campaignId || "all campaigns, "} for period: ${dateRange}`,
        campaignId: campaignId || "",
        filters,
        splits,
        schedule,
        email,
        defaultFilters: defaultFiltersRange,
        orderedColumns: orderedColumns.map((c) => c.label ? c : Object.assign(Object.assign({}, c), { label: c.id })),
        hiddenColumns: hiddenColumns
            ? Object.keys(hiddenColumns).filter((colId) => hiddenColumns[colId])
            : [],
        granularity,
    };
}
function normalizeStoredReportToReportContext({ id, name, campaignId, filters = {}, splits = [], granularity, defaultFilters, schedule, email, orderedColumns, hiddenColumns = [], }) {
    var _a, _b;
    const defaultFiltersNormalized = {};
    const { range, start, finish } = defaultFilters;
    const dateRange = range && ((_a = (0, dateRange_2.getDateRangeOptionByPeriodConfig)(range)) === null || _a === void 0 ? void 0 : _a.value);
    if (dateRange) {
        (0, lodash_set_1.default)(defaultFiltersNormalized, "range.value", dateRange);
    }
    else if (start && finish) {
        defaultFiltersNormalized.start = start;
        defaultFiltersNormalized.finish = finish;
        defaultFiltersNormalized.range = { value: dateRange_1.TimeRange.custom };
    }
    const granularitySplitIndex = splits.findIndex((s) => s.id === dbTableCampaign_1.DimensionIds.GRANULARITY_COLUMN_ID);
    if (granularitySplitIndex > -1) {
        const granularitySplit = splits[granularitySplitIndex];
        if (!granularitySplit.dictionary || !granularitySplit.value) { //for backward compatibility: if there's no granularitySplit.value, report is old and rely on granularity from defaultFilters
            splits[granularitySplitIndex] = (0, granularity_2.newGranularitySplit)((_b = granularitySplit.value) !== null && _b !== void 0 ? _b : granularity);
        }
    }
    return {
        id,
        name,
        campaignId,
        filters,
        splits,
        defaultFilters: defaultFiltersNormalized,
        hiddenColumns: (0, arrays_1.arrayToObject)({
            arr: hiddenColumns,
            valueModifier: () => true,
        }),
        orderedColumns,
        schedule,
        email,
    };
}
exports.UNNAMED_MULTI_CAMPAIGN_REPORT_PREFIX = "multi-campaigns_analytics_report_autosave";
exports.UNNAMED_REPORT_PREFIX = "unnamed_analytics_report";
exports.NAMED_REPORT_PREFIX = "named_analytics_report";
const generateUnnamedReportId = (campaignId, username) => `${exports.UNNAMED_REPORT_PREFIX}_${campaignId}_${username}`;
exports.generateUnnamedReportId = generateUnnamedReportId;
const generateUnnamedMultiReportId = (accountId, username) => `${exports.UNNAMED_MULTI_CAMPAIGN_REPORT_PREFIX}_${accountId}_${username}`;
exports.generateUnnamedMultiReportId = generateUnnamedMultiReportId;
const generateNamedReportId = () => `${exports.NAMED_REPORT_PREFIX}_${(0, uuid_1.v4)()}`;
exports.generateNamedReportId = generateNamedReportId;
const isNamedReport = (reportId) => reportId.startsWith(exports.NAMED_REPORT_PREFIX);
exports.isNamedReport = isNamedReport;
function getStartFinishOfStoredReport(defaultFilters) {
    var _a, _b, _c;
    const customRangeStart = (_a = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.start) === null || _a === void 0 ? void 0 : _a.value;
    const customRangeFinish = (_b = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.finish) === null || _b === void 0 ? void 0 : _b.value;
    if (customRangeStart && customRangeFinish) {
        return { startDate: customRangeStart, finishDate: customRangeFinish };
    }
    const range = defaultFilters.range;
    const startDate = (0, dateRange_2.startOf)((0, dateRange_2.subtractPeriod)((0, dateISO_1.getIsoDateNow)(), range.startUnitsAgo, range.unit), (0, dateRange_2.periodTypesToSingular)(range.unit));
    const finishDate = (0, dateRange_2.endOf)((0, dateRange_2.subtractPeriod)((0, dateISO_1.getIsoDateNow)(), (_c = range.endUnitsAgo) !== null && _c !== void 0 ? _c : 1, range.unit), (0, dateRange_2.periodTypesToSingular)(range.unit));
    return { startDate, finishDate };
}
